(function(){
    class Unclampable {
        clamp_class = '';
        wrapper = null;
        clampable_content = null;
        clamp_trigger = null;
        content_height = null;
        content_scroll_height = null;

        clampable_classes = ['line-clamp-1', 'line-clamp-2', 'line-clamp-3', 'line-clamp-4', 'line-clamp-5', 'line-clamp-6'];
        

        constructor(wrapper) {
            this.wrapper = wrapper;
            this.clampable_content = this.wrapper.querySelector('.js-unclampable__content');
            this.clamp_trigger = this.wrapper.querySelector('.js-unclampable__trigger');

            if (!this.clampable_content || !this.clamp_trigger) {
                return;
            }

            addEventListener('resize', this.resize.bind(this)); 
            this.clampable_classes.forEach(clamp_class => {
                if (this.clampable_content.classList.contains(clamp_class)) {
                    this.clamp_class = clamp_class;
                }
            });

            if(this.clamp_trigger && this.clamp_class) {
                this.clamp_trigger.addEventListener('click', this.toggle_clamp.bind(this));
            }
            this.setup_height();

        }

        setup_height() {    
            this.content_height = this.clampable_content.clientHeight;
            this.content_scroll_height = this.clampable_content.scrollHeight;
            if(this.content_scroll_height > this.content_height && this.clamp_class) {
                this.clamp_trigger.classList.remove('is-hidden');
            } else {
                this.clamp_trigger.classList.add('is-hidden');
                this.wrapper.classList.remove('is-active');
                if (this.clamp_class) {
                    this.clampable_content.classList.add(this.clamp_class);
                }
                this.set_trigger_state(false);
            }
        }

        resize() {
            this.setup_height();
        }

        toggle_clamp() {
            
            if(this.wrapper.classList.contains('is-active')) {
                
                this.wrapper.classList.remove('is-active');
                this.clampable_content.classList.add(this.clamp_class);
                this.set_trigger_state(false);
            } else {
                this.wrapper.classList.add('is-active');
                this.clampable_content.classList.remove(this.clamp_class);
                this.set_trigger_state(true);
            }
        }

        set_trigger_state(is_expanded) {
            const label = is_expanded
                ? this.clamp_trigger.getAttribute('data-label-collapse')
                : this.clamp_trigger.getAttribute('data-label-expand');

            this.clamp_trigger.setAttribute('aria-expanded', is_expanded ? 'true' : 'false');

            if (label) {
                this.clamp_trigger.setAttribute('aria-label', label);
            }
        }
        
    }
    const unclampables = document.querySelectorAll('.js-unclampable');

    if (unclampables.length) {
        unclampables.forEach(function(unclampable) {
            new Unclampable(unclampable);
        });
    }
})()
